import React, { useState, useEffect } from 'react';
import Api from "../../services/Api";
import Header from "../../components/header/Header";
import {ActionEnum, displayAction, reverseAction, RoomLogInterface, TeamInterface} from "../../interfaces/common";
import {shortDateTimeStr} from "../../helpers/dateFunctions";

interface RoomInterface {
  id: number;
  teamId: number;
  name: string;
}

interface ClientInterface {
  id: number;
  firstName: string;
  lastName: string;
}

interface NumBoolMap {
  [key: string]: boolean;
}


const Logging = () => {
  const api = Api.getInstance();
  const [from, setFrom] = useState<string>("2025-01-01");
  const [roomLogs, setRoomLogs] = useState<Array<RoomLogInterface>>([]);
  const [teams, setTeams] = useState<Array<TeamInterface>>([]);
  const [clients, setClients] = useState<Array<ClientInterface>>([]);
  const [rooms, setRooms] = useState<Array<RoomInterface>>([]);
  const [days, setDays] = useState(0)
  const [expandRoom, setExpandRoom] = useState<NumBoolMap>({});
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    getData()
  }, [])

  const getData = () => {
    let url = 'logging?from=' + from
    api.get(url).then(result => {
      setRoomLogs(result.json.roomLogs)
      setTeams(result.json.teams)
      setClients(result.json.clients)
      setDays(result.json.days)
      setRooms(result.json.rooms)
      setLoading(false)
    })
  }

  const showClient = (clientId: number) => {
    for (const client of clients) {
      if (client.id === clientId) {
        return client.firstName
      }
    }
    return "Unknown"
  }

  const sumAction = (mp: Object, action: string, total: number) => {
    let found = 0
    for (let [key, value] of Object.entries(mp)) {
      if (value === action) {
        found++
      }
    }
    return (found / total) * 100
  }

  const teamSummary = (team: TeamInterface) => {
    const teamRooms = []
    for (const room of rooms) {
      if (room.teamId === team.id) {
        teamRooms.push(room.id)
      }
    }
    const totalNr = days * teamRooms.length

    const activityMap:Object = {}
    const outdoorMap = {}
    for (const roomLog of roomLogs) {
      if (roomLog.roomId in teamRooms) {
        const key = roomLog.date + '_' + roomLog.roomId
        activityMap[key] = roomLog.activity
        outdoorMap[key] = roomLog.outdoor
      }
    }
    return (
      <div key={"team_" + team.id}>
        <div className="text-xl">
          {team.name}
        </div>
        {
          totalNr > 0 &&
            <>
                <div className="grid grid-cols-4">
                    <div></div>
                    <div>Inte frågat</div>
                    <div>Frågat</div>
                    <div>Genomfört</div>
                </div>
                <div className="grid grid-cols-4">
                    <div>Aktivitet</div>
                    <div>{sumAction(activityMap, ActionEnum.NONE, totalNr).toFixed(1)}%</div>
                    <div>{sumAction(activityMap, ActionEnum.ASKED, totalNr).toFixed(1)}%</div>
                    <div>{sumAction(activityMap, ActionEnum.ACCEPTED, totalNr).toFixed(1)}%</div>
                </div>
                <div className="grid grid-cols-4 mb-4">
                    <div>Utomhusvistelse</div>
                    <div>{sumAction(outdoorMap, ActionEnum.NONE, totalNr).toFixed(1)}%</div>
                    <div>{sumAction(outdoorMap, ActionEnum.ASKED, totalNr).toFixed(1)}%</div>
                    <div>{sumAction(outdoorMap, ActionEnum.ACCEPTED, totalNr).toFixed(1)}%</div>
                </div>
            </>
        }

      </div>
    )
  }

  const toggleRoom = (roomId: number) => {
    const newExpandRoom = {...expandRoom}
    newExpandRoom[roomId] = !expandRoom[roomId];
    setExpandRoom(newExpandRoom)
  }

  const showExpandedRoom = (room: RoomInterface)=> {
    if (!expandRoom[room.id]) {
      return <></>
    }
    return (
      <>
        <div className="grid grid-cols-5 mt-4 mb-2">
          <div>Datum</div>
          <div>Aktivitet</div>
          <div>Utomhusvistelse</div>
          <div>Loggat av</div>
          <div>Loggat</div>
        </div>
        {
          roomLogs.filter(roomLog => roomLog.roomId === room.id)
            .sort((a, b) => {return (b.date > a.date) ? 1 : -1})
            .map(roomLog => {
            return (
              <div className="grid grid-cols-5 mt-2">
                <div>{roomLog.date}</div>
                <div>{displayAction(roomLog.activity)}</div>
                <div>{displayAction(roomLog.outdoor)}</div>
                <div>{showClient(roomLog.clientId)}</div>
                <div>{shortDateTimeStr(roomLog.updatedAt)}</div>
              </div>
            )
            })
        }
      </>
    )
  }

  const roomSummary = (room: RoomInterface) => {

    const totalNr = days

    const activityMap:Object = {}
    const outdoorMap = {}
    for (const roomLog of roomLogs) {
      if (roomLog.roomId === room.id) {
        activityMap[roomLog.date] = roomLog.activity
        outdoorMap[roomLog.date] = roomLog.outdoor
      }
    }
    return (
      <div key={"room_" + room.id}>
        <div className="text-xl">
          {room.name}
        </div>
        {
          totalNr > 0 &&
            <>
                <div className="grid grid-cols-4">
                    <div></div>
                    <div>Inte frågat</div>
                    <div>Frågat</div>
                    <div>Genomfört</div>
                </div>
                <div className="grid grid-cols-4">
                    <div>Aktivitet</div>
                    <div>{sumAction(activityMap, ActionEnum.NONE, totalNr).toFixed(1)}%</div>
                    <div>{sumAction(activityMap, ActionEnum.ASKED, totalNr).toFixed(1)}%</div>
                    <div>{sumAction(activityMap, ActionEnum.ACCEPTED, totalNr).toFixed(1)}%</div>
                </div>
                <div className="grid grid-cols-4">
                    <div>Utomhusvistelse</div>
                    <div>{sumAction(outdoorMap, ActionEnum.NONE, totalNr).toFixed(1)}%</div>
                    <div>{sumAction(outdoorMap, ActionEnum.ASKED, totalNr).toFixed(1)}%</div>
                    <div>{sumAction(outdoorMap, ActionEnum.ACCEPTED, totalNr).toFixed(1)}%</div>
                </div>
                <div className="my-link" onClick={() => toggleRoom(room.id)}>
                  {expandRoom[room.id] ? "Mindre": "Läs mer"}
                </div>
                {showExpandedRoom(room)}
                <hr className="my-4" />
            </>
        }

      </div>
    )
  }

  const showResult = () => {
    if (loading) {
      return (
        <div className="bg-my-green text-white rounded-lg p-4 mt-4">
          Laddar data...
        </div>
      )
    } else {
      return (
        <>
          <div className="text-2xl text-center">Per team</div>
          <div className="bg-my-green text-white rounded-lg p-4 mt-4">
            {
              teams.map(team => {
                return teamSummary(team)
              })
            }
          </div>

          <div className="text-2xl text-center mt-6">Per rum</div>
          <div className="bg-my-green text-white rounded-lg p-4 mt-4">
            {
              rooms.map(room => {
                return roomSummary(room)
              })
            }
          </div>
        </>
      )
    }
  }

  return (
    <>
      <Header breadcrumbs={[{name: "Start", url: "/"}, {name: "Loggning"}]}/>
      <div className="page">
        <div className="content">
          {showResult()}
        </div>
      </div>
    </>
  )
}

export default Logging